import React from 'react';
import { formatPrice } from '../../utils/formatterUtils';

export default function RicaviMarginiCard({ data }) {
  if (!data?.ricaviMargini) return null;
  const {
    ricavi,
    attesi,
    incassatiPerc,
    margineEuro,
    marginePerc,
    prezzoMedioUnita,
    prezzoMedioMq,
    prezzoMedioBox,
    roi,
  } = data.ricaviMargini;

  return (
    <article className="card-dash card--ricaviMargini">
      <h3>Ricavi e Margini</h3>

      <div className="kpi-item--ricaviMargini">
        <span className="kpi-label--ricaviMargini">Ricavi Totali Incassati / Da Incassare</span>
        <span className="kpi-value--ricaviMargini">{formatPrice(ricavi)}</span>
        <span className="kpi-sub--ricaviMargini">vs attesi {formatPrice(attesi)} (compresi box)</span>
        <div className="kpi-dual--ricaviMargini">
          <div className="track--ricaviMargini">
            <span className="attesi--ricaviMargini" style={{ width: '100%' }}></span>
            <span
              className="incassati--ricaviMargini"
              style={{ width: `${Math.min(incassatiPerc, 100)}%` }}
            ></span>
          </div>
          <span className={`pill--ricaviMargini ${incassatiPerc >= 100 ? 'ok' : 'warn'}`}>
            {incassatiPerc.toFixed(0)}%
          </span>
        </div>
      </div>

      <div className="kpi-item--ricaviMargini">
        <span className="kpi-label--ricaviMargini">Margine lordo (con costi banca)</span>
        <span className="kpi-value--ricaviMargini">{formatPrice(margineEuro)}</span>
        <span className="kpi-sub--ricaviMargini">{marginePerc.toFixed(2)}%</span>
      </div>

      <div className="kpi-item--ricaviMargini">
        <span className="kpi-label--ricaviMargini">Prezzo medio di vendita</span>
        <span className="kpi-value--ricaviMargini">{formatPrice(prezzoMedioUnita)}</span>
        <span className="kpi-sub--ricaviMargini">per unità immobiliare</span>
      </div>

      <div className="kpi-item--ricaviMargini">
        <span className="kpi-label--ricaviMargini">Prezzo medio al mq</span>
        <span className="kpi-value--ricaviMargini">{formatPrice(prezzoMedioMq)}</span>
        <span className="kpi-sub--ricaviMargini">per mq</span>
      </div>

      <div className="kpi-item--ricaviMargini">
        <span className="kpi-label--ricaviMargini">Prezzo medio box</span>
        <span className="kpi-value--ricaviMargini">{formatPrice(prezzoMedioBox)}</span>
        <span className="kpi-sub--ricaviMargini">per box</span>
      </div>

      <div className="kpi-item--ricaviMargini">
        <span className="kpi-label--ricaviMargini">Indice di redditività</span>
        <span className="kpi-value--ricaviMargini">{roi.toFixed(2)}</span>
        <span className="kpi-sub--ricaviMargini">(ROI)</span>
      </div>
    </article>
  );
}
